import type { AvatarMode } from './customAvatar';

export interface SpriteColors {
  hair: string;
  clothing: string;
}

export interface AvatarLayerSelection {
  body: string;
  eyes: string;
  hairstyle: string;
  outfit: string;
  accessory: string | null;
  prop: string | null;
}

export const DEFAULT_SPRITE_COLORS: SpriteColors = {
  hair: '#8b5a2b',
  clothing: '#457b9d',
};

export interface UserProfile {
  displayName: string;
  bio: string;
  hasCompletedCharacterSetup?: boolean;
  spriteId: string;
  spriteColors: SpriteColors;
  avatarLayers?: AvatarLayerSelection;
  avatarMode?: AvatarMode;
  customAvatarId?: string | null;
  isAnonymous: boolean;
  isApproved: boolean;
  role: 'user' | 'admin';
  createdAt?: Date;
  lastSeen?: Date;
}

export interface AvatarFormValues {
  displayName: string;
  bio: string;
  spriteId: string;
  spriteColors: SpriteColors;
  avatarLayers?: AvatarLayerSelection;
  avatarMode?: AvatarMode;
  customAvatarId?: string | null;
}
